import { ISearchPage, IPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";

export interface IDiscernDetails {
    "id": string,   // "公告id",
    "code": string,   // "项目编码",
    "name": string,   // "项目名称",
    "title": string,   // "标题",
    "issueTime": string,   // "发布日期",
    "openTime": string,   // "开标日期",
    "endTime": string,   // "截止日期",
    "source": string,   // "来源",
    "region": string,   // "地区",
    "content": string,   // "公告内容",
    "planCode": string,   // "采购计划号",
    "purchaseUnit": string,   // "采购单位",
    "projectOverview": string,   // "项目概况",
    "bidMethod": string,   // "招标方式",
    "bidCode": string,   // "招标编号",
    "sellingPrice": string,   // "售价",
    "price": string,   // "预算金额",
    "readNum": string,   // "阅读次数",
    "relation": string,   // "关联公告",
    "link": string,   // "链接", 
    "pdfviewLink": string,   // "pdf查看链接", 
    "currency": string,   // "货币",
    "validity": string,   // "有效期",
    "payment": string,   // "缴纳形式",
    "bidUnit": string,   // "招标人",
    "address": string,   // "招标人地址",
    "contacts": string,   // "联系人及电话",
    "email": string,   // "邮箱",
    "agency": string,   // "代理招标人",
    "agencyAddress": string,   // "代理招标地址",
    "agencyContacts": string,   // "代理联系人及电话",
    "agencyEmail": string,   // "代理邮箱",
    "projectContacts": string,   // "项目联系人",
    "projectPhone": string,   // "项目联系方式",
    "specsBriefly": string,   // "规格简要",
    "deliveryAddress": string,   // "交货地点",
    "deliveryTime": string,   // "交货时间",
    "progress": string,   // "进展情况",
    "grade": string,   // "等级",
    "keyword": string,   // "关键词",
    "notice": string,   // "公告类型",
    "isJoin": string,   // "是否参与",
    "status": string,   // "状态"
    "textContent": string,  //文本内容
    "detailLink": string,  //iframe 
    "keywords": string,  //iframe 
    "sourceFrom": string,  //iframe 
    "bidStartTime": string,
    "seeStatus": number,
    "seeTime": string,
    "pubTime": string,  //发布时间
    "rawContent": string,
    "oid": string
};

export interface IDiscernSeachFields {
    "keyword"?: string,      // "关键词",
    "region"?: string,      // "地区",
    "source"?: string,      // "来源",
    "date"?: string,      // "截止日期",
    "startTime"?: string,      // "截止开始时间",
    "endTime"?: string,      // "截止结束时间",
    "isJoin"?: string,      // "是否参与",
    "notice"?: string,      // "公告类型",
    "pubTime"?: string,  //发布时间
    "status"?: string,
    [key: string]: any
};
export interface IDiscernSearch extends
    IDiscernSeachFields, ISearchPage {

}


//信息标注
export interface IDistinguishUpdateField {
    "id"?: string,   // "公告id",
    "code"?: string,   // "项目编码",
    "name"?: string,   // "项目名称",
    "specsBriefly"?: string,   // "规格简要",
    "title"?: string,   // "标题",
    "region"?: string,   // "地区",
    "issueTime"?: string,   // "发布日期",
    "endTime"?: string,   // "截止日期",
    "sellingPrice"?: string,   // "售价",
    "deliveryAddress"?: string,   // "交货地点",
    "deliveryTime"?: string,   // "交货时间",
    "bidUnit"?: string,   // "招标人",
    "address"?: string,   // "招标人地址",
    "contacts"?: string,   // "联系人及电话",
    "email"?: string,   // "邮箱",
    "agency"?: string,   // "代理招标人",
    "agencyAddress"?: string,   // "代理招标地址",
    "agencyContacts"?: string,   // "代理联系人及电话",
    "agencyEmail"?: string,   // "代理邮箱",
    "link"?: string,   // "链接", 
    "pdfviewLink"?: string,   // "pdf查看链接", 
    "progress"?: string,   // "进展情况",
    "grade"?: string,   // "等级",
    "keyword"?: string,   // "关键词",
    "notice"?: string,   // "公告类型",
    "isJoin"?: string,   // "是否参与",
    "status"?: string,   // "状态",
    "seeStatus"?: number,
    "seeTime"?: string,
    "pubTime"?: string,  //发布时间
}


//开标结果
export interface ILabelResultOne {
    "id"?: string,    // "开标结果id",
    "distinguishId": string,    // "公告id",
    "bidCompany": string,    // "开标公司",
    "bidModel": string,    // "投标车型",
    "num": string,    // "投标数量",
    "price": string,    // "投标金额",
    "hitCompany": string,    // "中标公司",
    "hitPrice": string,    // "中标金额",
    "status": string,    // "状态",
    "reason": string,    // "原因",
    "openTime": string,    // "开标日期",
    "note": string,    // "备注"
}

class DiscernService {
    //公告列表
    async page(searchVo: IDiscernSearch) {
        const apiUrl = "/distinguish/page";
        return await httpRequest.post<IPage<IDiscernDetails>>(apiUrl, searchVo);
    }
    //查询单条公告信息
    async distinguishOne(id: string) {
        const apiUrl = `/distinguish/one/${id}`;
        return await httpRequest.get<IDiscernDetails>(apiUrl);
    }
    //作废单条公告信息
    async distinguishCancel(id: string) {
        const apiUrl = `/distinguish/cancel/one/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    //信息标注
    async distinguishUpdate(obj: IDistinguishUpdateField) {
        const apiUrl = "/distinguish/update";
        return await httpRequest.post<boolean>(apiUrl, obj);
    }
    //标注第一次查看时间
    async distinguishUpdateSee(obj: IDistinguishUpdateField) {
        const apiUrl = "/distinguish/updateSee";
        return await httpRequest.post<boolean>(apiUrl, obj);
    }
    //地区查询
    async distinguishAddress() {
        const apiUrl = "/distinguish/listRegion";
        return await httpRequest.get<string[]>(apiUrl);
    }
    //下载
    async downloadFile(searchVo: { id: string }) {
        const appPageUrl = "/distinguish/export";
        return await httpRequest.postFile(appPageUrl, searchVo, { timeout: 300000 });
    }
    //批量删除
    async removeAll(searchVo: string[]) {
        const appPageUrl = "/distinguish/cancels";
        return await httpRequest.post(appPageUrl, searchVo);
    }

    //查询单条开标结果信息
    async labelResultOne(id: string) {
        const apiUrl = `/labelResults/one/${id}`;
        return await httpRequest.get<ILabelResultOne>(apiUrl);
    }
    //新增数开标结果
    async labelResultInsert(obj: ILabelResultOne) {
        const apiUrl = "/labelResults/insert";
        return await httpRequest.post<boolean>(apiUrl, obj);
    }
    //编辑数开标结果
    async labelResultUpdate(obj: ILabelResultOne) {
        const apiUrl = "/labelResults/update";
        return await httpRequest.post<boolean>(apiUrl, obj);
    }

}

export const discernService = new DiscernService(); 